import { useState } from 'react';
import { useSelector } from 'react-redux';
import EarningsModal from './EarningsBody';
import styles from './index.module.scss';

const Earnings = (props: any) => {
	const { year, month, employeeId, activeTab, isUsd } = props;

	const [earningsAmount, setEarningsAmount] = useState<number>(0);
	const [isFetchDataLoading, setIsFetchDataLoading] =
		useState<boolean>(false);

	const { baseCurrencySymbol, usdCurrencySymbol } = useSelector(
		(state: any) => state.userProfile.data
	);

	return (
		<div>
			<div className={styles.earningContainer}>
				<div className={styles.headerBox}>
					<div className={styles.headerContent}>
						{/* Header Section */}
						<div className={styles.titleContainer}>
							<div className={styles.titleText}>Earnings</div>
							<div className={styles.separation}></div>
							<div className={styles.earningsCount}>
								<div className={styles.titleEarnings}>
									Total Earnings
								</div>
								<div className={styles['earningsAmount']}>
									{isUsd
										? usdCurrencySymbol
										: baseCurrencySymbol}
										{!isFetchDataLoading && earningsAmount != null ? earningsAmount?.toFixed(2) : ''}
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* Earnings Modal */}
				<EarningsModal
					month={month}
					year={year}
					employeeId={employeeId}
					activeTab={activeTab}
					isUSD={isUsd}
					setEarningsAmount={setEarningsAmount}
					setIsLoading={setIsFetchDataLoading}
					isLoading={isFetchDataLoading}
				/>
				{/* Buttons */}
			</div>
		</div>
	);
};

export default Earnings;
